var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d904d4c0f35015828ce8da6298caea7ecf5c625c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yoco-com@yoco-technologies"]={id:"d904d4c0f35015828ce8da6298caea7ecf5c625c"};
      